export const SIMPLE_HEADERS = ["Member name", "Registered email", "Payment or credit reference",
  "Date (YYYY-MM-DD)", "What are you recording?", "Money received (Rs)",
  "Included Allocation Credit (Rs)", "Favcy Added Allocation Credit (Rs)",
  "Can the extra credit be used now?", "What must happen first?", "Notes"] as const;

export const WORKBOOK_HEADERS = ["investor_name", "investor_email", "transaction_reference", "transaction_date", "transaction_type",
  "payment_received_inr", "included_allocation_credit_added_inr", "favcy_added_allocation_credit_inr",
  "favcy_credit_status", "favcy_credit_conditions", "notes"] as const;

export interface CreditSummary {
  paymentReceived: number; includedCredit: number; addedCredit: number; conditionalCredit: number;
  appliedIncluded: number; appliedAdded: number; remainingIncluded: number; remainingAdded: number; remainingAvailable: number;
}
export interface CreditEntry {
  released?: boolean; releaseOf?: number | null;
  id: number; reference: string; date: string; kind: string; payment: number; included: number; added: number;
  conditional: number; appliedIncluded: number; appliedAdded: number; companyId: number | null;
  notes: string | null; conditions: string | null; createdBy: string | null; createdAt: string;
}
export interface CreditLedger {
  summary: CreditSummary | null; entries: CreditEntry[];
  companies?: { id: number; name: string }[]; members?: { id: number; name: string; email: string }[];
}
export interface CreditPreviewRow {
  index: number; rowNumber: number; investorId: number | null; name: string; email: string;
  status: "ready" | "duplicate" | "blocked"; issues: string[]; payment: number; included: number; added: number; conditional: number;
}
export interface CreditPreview { reviewHash: string; rows: CreditPreviewRow[]; summary: { ready: number; duplicate: number; blocked: number } }

export function rupees(n: number | null | undefined): string {
  const v = Number(n) || 0;
  return `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

export function kindLabel(kind: string): string {
  const k = kind.toLowerCase();
  if (k.includes("alloc")) return "Allocation";
  if (k.includes("release")) return "Conditional release";
  if (k.includes("credit")) return "Credit only";
  if (k.includes("pay")) return "Payment";
  return kind.replace(/_/g, " ");
}

export function fmtDate(d: string | null | undefined): string {
  if (!d) return "—";
  const t = new Date(d);
  return isNaN(t.getTime()) ? d : t.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function todayISO(): string { return new Date().toISOString().slice(0, 10); }

export async function readApiError(r: Response): Promise<string> {
  const b = await r.json().catch(() => null);
  return b?.error?.message || b?.message || (typeof b?.error === "string" ? b.error : "") || `Request failed (${r.status})`;
}
